export const settings_custom_field_en = {
  settings_custom_field_title: "Custom contact fields",
  settings_custom_field_desc:
    "Enable tailored data entry and adaptation to unique business processes.",
  settings_custom_field_column_crm_schema: "CRM Schema",
  settings_custom_field_column_field_name: "Field Name",
  edit_custom_field_dialog_title: "Edit Custom Field",
  new_custom_field: "New field",
};

export const settings_custom_field_zh_cn = {
  settings_custom_field_title: "自定义联系人字段",
  settings_custom_field_desc: "支持个性化数据录入，适应独特的业务流程。",
  settings_custom_field_column_crm_schema: "CRM 架构",
  settings_custom_field_column_field_name: "字段名称",
  edit_custom_field_dialog_title: "编辑自定义字段",
  new_custom_field: "新建字段",
};

export const settings_custom_field_zh_tw = {
  settings_custom_field_title: "自訂聯絡人欄位",
  settings_custom_field_desc: "啟用量身打造的資料輸入方式，配合獨特業務流程。",
  settings_custom_field_column_crm_schema: "CRM 架構",
  settings_custom_field_column_field_name: "欄位名稱",
  edit_custom_field_dialog_title: "編輯自訂欄位",
  new_custom_field: "新增欄位",
};

export const settings_custom_field_japanese = {
  settings_custom_field_title: "カスタム連絡先フィールド",
  settings_custom_field_desc: "独自のビジネスプロセスに合わせたデータ入力方法を有効にします。",
  settings_custom_field_column_crm_schema: "CRMスキーマ",
  settings_custom_field_column_field_name: "フィールド名",
  edit_custom_field_dialog_title: "カスタムフィールドを編集",
  new_custom_field: "新規フィールド"
};


export const settings_custom_field_korean = {
  settings_custom_field_title: "사용자 정의 연락처 필드",
  settings_custom_field_desc: "고유한 비즈니스 프로세스에 맞춘 데이터 입력 방식을 활성화합니다.",
  settings_custom_field_column_crm_schema: "CRM 스키마",
  settings_custom_field_column_field_name: "필드 이름",
  edit_custom_field_dialog_title: "사용자 정의 필드 편집",
  new_custom_field: "새 필드 추가"
};

export const settings_custom_field_hindi = {
  settings_custom_field_title: "कस्टम संपर्क फ़ील्ड",
  settings_custom_field_desc: "अनूठे व्यावसायिक प्रक्रियाओं के अनुरूप डेटा इनपुट विधियों को सक्षम करें।",
  settings_custom_field_column_crm_schema: "CRM स्कीमा",
  settings_custom_field_column_field_name: "फ़ील्ड नाम",
  edit_custom_field_dialog_title: "कस्टम फ़ील्ड संपादित करें",
  new_custom_field: "नया फ़ील्ड जोड़ें"
};